<ll-titulo>Subir Prueba Propia de tipo {{ evaluacionTipo }}</ll-titulo>
<subir-prueba-propia [evaluacionTipo]="evaluacionTipo"></subir-prueba-propia>
